/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateReinsuredPayloadDto,
  ErrorResponse,
  ReinsuredPaginationResponseDto,
  ReinsuredResponseDto,
  UpdateReinsuredPayloadDto,
} from '../models/index';
import {
    CreateReinsuredPayloadDtoFromJSON,
    CreateReinsuredPayloadDtoToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    ReinsuredPaginationResponseDtoFromJSON,
    ReinsuredPaginationResponseDtoToJSON,
    ReinsuredResponseDtoFromJSON,
    ReinsuredResponseDtoToJSON,
    UpdateReinsuredPayloadDtoFromJSON,
    UpdateReinsuredPayloadDtoToJSON,
} from '../models/index';

export interface CreateReinsuredRequest {
    createReinsuredPayloadDto: CreateReinsuredPayloadDto;
}

export interface DeleteReinsuredByIdRequest {
    reinsuredId: string;
}

export interface FilterReinsuredsRequest {
    searchText?: string;
    status?: FilterReinsuredsStatusEnum;
    field?: FilterReinsuredsFieldEnum;
    order?: FilterReinsuredsOrderEnum;
    page?: number;
    pageSize?: number;
}

export interface GetReinsuredByIdRequest {
    reinsuredId: string;
    prefetchChangelogs?: number;
}

export interface UpdateReinsuredRequest {
    reinsuredId: string;
    updateReinsuredPayloadDto: UpdateReinsuredPayloadDto;
}

/**
 * 
 */
export class ReinsuredApi extends runtime.BaseAPI {

    /**
     * Create reinsured
     */
    async createReinsuredRaw(requestParameters: CreateReinsuredRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReinsuredResponseDto>> {
        if (requestParameters['createReinsuredPayloadDto'] == null) {
            throw new runtime.RequiredError(
                'createReinsuredPayloadDto',
                'Required parameter "createReinsuredPayloadDto" was null or undefined when calling createReinsured().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/reinsured`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateReinsuredPayloadDtoToJSON(requestParameters['createReinsuredPayloadDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReinsuredResponseDtoFromJSON(jsonValue));
    }

    /**
     * Create reinsured
     */
    async createReinsured(requestParameters: CreateReinsuredRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReinsuredResponseDto> {
        const response = await this.createReinsuredRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete reinsured by id
     */
    async deleteReinsuredByIdRaw(requestParameters: DeleteReinsuredByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['reinsuredId'] == null) {
            throw new runtime.RequiredError(
                'reinsuredId',
                'Required parameter "reinsuredId" was null or undefined when calling deleteReinsuredById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/reinsured/{reinsuredId}`.replace(`{${"reinsuredId"}}`, encodeURIComponent(String(requestParameters['reinsuredId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete reinsured by id
     */
    async deleteReinsuredById(requestParameters: DeleteReinsuredByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteReinsuredByIdRaw(requestParameters, initOverrides);
    }

    /**
     * Filter reinsureds
     */
    async filterReinsuredsRaw(requestParameters: FilterReinsuredsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReinsuredPaginationResponseDto>> {
        const queryParameters: any = {};

        if (requestParameters['searchText'] != null) {
            queryParameters['searchText'] = requestParameters['searchText'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['field'] != null) {
            queryParameters['field'] = requestParameters['field'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = requestParameters['order'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/reinsured/filter`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReinsuredPaginationResponseDtoFromJSON(jsonValue));
    }

    /**
     * Filter reinsureds
     */
    async filterReinsureds(requestParameters: FilterReinsuredsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReinsuredPaginationResponseDto> {
        const response = await this.filterReinsuredsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get reinsured by id
     */
    async getReinsuredByIdRaw(requestParameters: GetReinsuredByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReinsuredResponseDto>> {
        if (requestParameters['reinsuredId'] == null) {
            throw new runtime.RequiredError(
                'reinsuredId',
                'Required parameter "reinsuredId" was null or undefined when calling getReinsuredById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['prefetchChangelogs'] != null) {
            queryParameters['prefetchChangelogs'] = requestParameters['prefetchChangelogs'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/reinsured/{reinsuredId}`.replace(`{${"reinsuredId"}}`, encodeURIComponent(String(requestParameters['reinsuredId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReinsuredResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get reinsured by id
     */
    async getReinsuredById(requestParameters: GetReinsuredByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReinsuredResponseDto> {
        const response = await this.getReinsuredByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update reinsured
     */
    async updateReinsuredRaw(requestParameters: UpdateReinsuredRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReinsuredResponseDto>> {
        if (requestParameters['reinsuredId'] == null) {
            throw new runtime.RequiredError(
                'reinsuredId',
                'Required parameter "reinsuredId" was null or undefined when calling updateReinsured().'
            );
        }

        if (requestParameters['updateReinsuredPayloadDto'] == null) {
            throw new runtime.RequiredError(
                'updateReinsuredPayloadDto',
                'Required parameter "updateReinsuredPayloadDto" was null or undefined when calling updateReinsured().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/reinsured/{reinsuredId}`.replace(`{${"reinsuredId"}}`, encodeURIComponent(String(requestParameters['reinsuredId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateReinsuredPayloadDtoToJSON(requestParameters['updateReinsuredPayloadDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReinsuredResponseDtoFromJSON(jsonValue));
    }

    /**
     * Update reinsured
     */
    async updateReinsured(requestParameters: UpdateReinsuredRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReinsuredResponseDto> {
        const response = await this.updateReinsuredRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const FilterReinsuredsStatusEnum = {
    Active: 'Active',
    Inactive: 'Inactive'
} as const;
export type FilterReinsuredsStatusEnum = typeof FilterReinsuredsStatusEnum[keyof typeof FilterReinsuredsStatusEnum];
/**
 * @export
 */
export const FilterReinsuredsFieldEnum = {
    Name: 'name'
} as const;
export type FilterReinsuredsFieldEnum = typeof FilterReinsuredsFieldEnum[keyof typeof FilterReinsuredsFieldEnum];
/**
 * @export
 */
export const FilterReinsuredsOrderEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;
export type FilterReinsuredsOrderEnum = typeof FilterReinsuredsOrderEnum[keyof typeof FilterReinsuredsOrderEnum];
